import React, { useMemo, useState, useEffect, useCallback } from 'react';

export const AccordianList = (props) => {
    const { numberOfItemToShow = 5, list, ItemComponent, showMoreTitle = '', showLessTitle = 'Show Less', itemProps = {}, itemKey = '_id' } = props;
    const [numberOfItemsShow, setNumberOfItemsToShow] = useState(numberOfItemToShow);
    const [bottomLabel, setBottomLabel] = useState('');

    const expandMemberList = () => {
        setNumberOfItemsToShow(list.length);
        setBottomLabel(showLessTitle);
    };

    const contractMemberList = useCallback(() => {
        setNumberOfItemsToShow(numberOfItemToShow);
        setBottomLabel(showMoreTitle);
    }, [numberOfItemToShow, showMoreTitle]);

    const toggleMemberListSize = () => {
        if (bottomLabel === showLessTitle) {
            contractMemberList();
        } else {
            expandMemberList();
        }
    };

    const getBottomIcon = () => {
        const lookup = {
            [showMoreTitle]: 'expand_more',
            [showLessTitle]: 'expand_less',
        };
        if (lookup[bottomLabel]) return lookup[bottomLabel];
        return '';
    };

    useEffect(() => {
        if (list?.length <= numberOfItemToShow) {
            setBottomLabel('');
        }
        if (list?.length > numberOfItemToShow) {
            contractMemberList();
        }
    }, [list, contractMemberList, numberOfItemToShow]);

    const listToShow = useMemo(() => {
        return list?.slice(0, numberOfItemsShow)?.map((item) => <ItemComponent key={item[itemKey]} item={item} {...itemProps} />);
    }, [list, numberOfItemsShow, itemProps, itemKey]);

    return (
        <div>
            {listToShow && listToShow}
            {list.length > numberOfItemToShow && (
                <div className='flex cursor-pointer' onClick={toggleMemberListSize}>
                    <p className='text-font12 font-normal text-scogoorange'>{bottomLabel}</p>
                    <span className='material-icons text-scogoorange text-font16 ml-2'>{getBottomIcon()}</span>
                </div>
            )}
        </div>
    );
};
